import { useNavigate } from 'react-router-dom';
import OutsideClickHandler from 'react-outside-click-handler';
import { Box, Flex, Image, useDisclosure } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import useLogout from 'Domain/logout/usePostLogout';
import logoImage from 'Asset/image/logo.svg';
import { ArrowLeftIcon, ChevronDownIcon, CloseIcon, OutIcon, UserCircleIcon } from 'Asset/icon';
import { Condition, Element } from 'Component/others';
import LanguageChanger from 'Component/language-changer';
import { TextBold, TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';
import Notification from 'Component/notification';

const ProfilePopup = ({ onLogout }) => {
  const { t } = useTranslation();
  return (
    <Box className={styles['profile-popup__container']}>
      <LanguageChanger variant="inline" />

      <Flex className={styles['logout__container']} onClick={onLogout}>
        <OutIcon color="var(--color-semantic-black)" size="14px" />
        <TextBold className={styles['logout__text']}>{t('logout')}</TextBold>
      </Flex>
    </Box>
  );
};

const HeaderMobile = ({ title, onClick, type = 'header-logo', rightSection }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate: onLogout } = useLogout();
  const navigate = useNavigate();

  const onClickArrow = () => {
    if (onClick) onClick();
    else navigate(-1);
  };

  return (
    <Box className={styles['header-mobile__container']}>
      <Condition statement={type === 'header-logo'}>
        <Flex className={styles['header-logo__container']}>
          <Image src={logoImage} className={styles['logo__image']} />
          <Flex gap="18px" alignItems="center">
            <Notification />
            <Condition statement={!isOpen} fallback={<UserCircleIcon onClick={onClose} />}>
              <UserCircleIcon onClick={onOpen} />
            </Condition>
          </Flex>

          <Condition statement={isOpen}>
            <Flex className={styles['logout__wrapper']}>
              <OutsideClickHandler onOutsideClick={onClose}>
                <ProfilePopup onLogout={onLogout} />
              </OutsideClickHandler>
            </Flex>
          </Condition>
        </Flex>
      </Condition>

      <Condition statement={type === 'header-back'}>
        <Flex className={styles['header-back__container']}>
          <Flex className={styles['left__section']}>
            <ArrowLeftIcon onClick={onClickArrow} size="20px" />
            <TextSemiBold className={styles['title']}>{title}</TextSemiBold>
          </Flex>

          <Flex className={styles['right__section']}>
            <Element value={rightSection} />
          </Flex>
        </Flex>
      </Condition>

      <Condition statement={type === 'header-dropdown'}>
        <Flex className={styles['header-back__container']}>
          <Flex className={styles['left__section']}>
            <ChevronDownIcon onClick={onClickArrow} size="20px" />
            <TextSemiBold className={styles['title']}>{title}</TextSemiBold>
          </Flex>

          <Flex className={styles['right__section']}>
            <Element value={rightSection} />
          </Flex>
        </Flex>
      </Condition>

      <Condition statement={type === 'header-close'}>
        <Flex className={styles['header-back__container']}>
          <Flex className={styles['left__section']}>
            <CloseIcon onClick={onClickArrow} size="20px" />
            <TextSemiBold className={styles['title']}>{title}</TextSemiBold>
          </Flex>

          <Flex className={styles['right__section']}>
            <Element value={rightSection} />
          </Flex>
        </Flex>
      </Condition>
    </Box>
  );
};

export default HeaderMobile;
